var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B4CCB9",
    d: "M32.516,53.933C32.347,53.978,32.173,54,32,54s-0.347-0.022-0.516-0.067L2,46.07v1.954l30,7.941l30-7.941 V46.07L32.516,53.933z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4CCB9",
    d: "M32,58c-0.086,0-0.172-0.011-0.256-0.033L2,50.093v1.906l25.033,6.676l1.987,0.53 c0.079,1.143,0.785,2.111,1.788,2.546l0.676,0.181c0.169,0.045,0.343,0.067,0.516,0.067s0.347-0.022,0.516-0.067l0.676-0.181 c1.003-0.435,1.709-1.403,1.788-2.546l1.987-0.53L62,51.999v-1.906l-29.744,7.874C32.172,57.989,32.086,58,32,58z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#F9EBB2",
    points: "2.001,2.001 1.998,2.001 2,44 31,51.733 31,9.733 2.001,2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F9EBB2",
    points: "33,9.733 33,51.733 62,44 62,2  "
  })), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#231F20",
    points: "33,9.733 33,51.733 62,44 62,2  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M8.992,29.828l14.467,4.134C23.551,33.987,23.643,34,23.734,34c0.435,0,0.835-0.286,0.961-0.726 c0.151-0.53-0.156-1.084-0.688-1.236L9.541,27.904c-0.527-0.146-1.084,0.155-1.236,0.688C8.153,29.122,8.461,29.676,8.992,29.828z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M8.992,36.829l14.467,4.133C23.551,40.987,23.643,41,23.734,41c0.435,0,0.835-0.286,0.961-0.726 c0.151-0.531-0.156-1.084-0.688-1.236L9.541,34.905c-0.527-0.146-1.084,0.155-1.236,0.688C8.153,36.124,8.461,36.677,8.992,36.829 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M8.992,22.828l14.467,4.134C23.551,26.987,23.643,27,23.734,27c0.435,0,0.835-0.286,0.961-0.726 c0.151-0.53-0.156-1.084-0.688-1.236L9.541,20.904c-0.527-0.146-1.084,0.155-1.236,0.688C8.153,22.122,8.461,22.676,8.992,22.828z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M8.992,15.828l14.467,4.134C23.551,19.987,23.643,20,23.734,20c0.435,0,0.835-0.286,0.961-0.726 c0.151-0.53-0.156-1.084-0.688-1.236L9.541,13.904c-0.527-0.146-1.084,0.155-1.236,0.688C8.153,15.122,8.461,15.676,8.992,15.828z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M39.963,33.962c0.092,0,0.184-0.013,0.275-0.038l14.467-4.134c0.531-0.152,0.839-0.706,0.688-1.236 c-0.152-0.532-0.708-0.832-1.236-0.688L39.689,32c-0.531,0.152-0.839,0.706-0.688,1.236 C39.128,33.676,39.528,33.962,39.963,33.962z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M54.459,34.905l-14.467,4.133c-0.531,0.152-0.839,0.705-0.688,1.236C39.431,40.714,39.831,41,40.266,41 c0.092,0,0.184-0.013,0.275-0.038l14.467-4.133c0.531-0.152,0.839-0.705,0.688-1.236C55.543,35.061,54.987,34.761,54.459,34.905z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M40.266,27c0.092,0,0.184-0.013,0.275-0.038l14.467-4.134c0.531-0.152,0.839-0.706,0.688-1.236 c-0.152-0.532-0.708-0.834-1.236-0.688l-14.467,4.134c-0.531,0.152-0.839,0.706-0.688,1.236C39.431,26.714,39.831,27,40.266,27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M40.266,20c0.092,0,0.184-0.013,0.275-0.038l14.467-4.134c0.531-0.152,0.839-0.706,0.688-1.236 c-0.152-0.532-0.708-0.832-1.236-0.688l-14.467,4.134c-0.531,0.152-0.839,0.706-0.688,1.236C39.431,19.714,39.831,20,40.266,20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M63.219,0.414c-0.354-0.271-0.784-0.413-1.221-0.413c-0.172,0-0.345,0.022-0.514,0.066L32,7.93 L2.516,0.067c-0.17-0.045-0.343-0.066-0.515-0.066c-0.437,0-0.866,0.142-1.22,0.413C0.289,0.793,0,1.379,0,2v49.999 c0,0.906,0.609,1.699,1.484,1.933l25.873,6.899C28.089,62.685,29.887,64,32,64s3.911-1.315,4.643-3.169l25.873-6.899 C63.391,53.698,64,52.905,64,51.999V2C64,1.379,63.711,0.793,63.219,0.414z M2.001,2.001L2.001,2.001L31,9.733v42L2,44 L1.998,2.001C1.998,2.001,1.999,2.001,2.001,2.001z M62,51.999l-25.033,6.676l-1.987,0.53c-0.079,1.143-0.785,2.111-1.788,2.546 l-0.676,0.181c-0.169,0.045-0.343,0.067-0.516,0.067s-0.347-0.022-0.516-0.067l-0.676-0.181c-1.003-0.435-1.709-1.403-1.788-2.546 l-1.987-0.53L2,51.999v-1.906l29.744,7.874C31.828,57.989,31.914,58,32,58s0.172-0.011,0.256-0.033L62,50.093V51.999z M62,48.024 l-30,7.941L2,48.024V46.07l29.484,7.862C31.653,53.978,31.827,54,32,54s0.347-0.022,0.516-0.067L62,46.07V48.024z M62,44 l-29,7.733v-42L62,2V44z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.1e969e377a3f838f7f73843682ab531d.svg";
export { ForwardRef as ReactComponent };